import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

/**
 * Components must implement this interface to use this guard
 */
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard {
  canDeactivate(component: CanComponentDeactivate) {
    // TODO: solve canDeactivate in view components
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
